<template>
    <v-dialog v-model="dialogFSC" max-width="800px" persistent @keydown.esc="chiudiDialogFSC">
        <v-container style="background-color: white;">

            <v-row class="ma-0 pa-0">
                <v-btn icon @click="caricaDati">
                    <v-icon>refresh</v-icon>
                </v-btn>

                <v-btn color="success" @click="apriDialogItem()" small class="mt-1 ml-2">
                    <v-icon left>add</v-icon> Aggiungi elemento
                </v-btn>

                <v-spacer />
                <v-btn icon @click="chiudiDialogFSC">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-row>

            <v-text-field v-model="search" append-icon="search" label="Cerca..." class="mt-2 mb-2" solo clearable />

            <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1" hide-default-footer
                :items-per-page="-1" fixed-header height="60vh" dense no-data-text="Nessun dato disponibile">
                <template v-slot:item.actions="{ item }">
                    <v-btn icon color="primary" @click="apriDialogItem(item)">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="duplicaElemento(item)">
                        <v-icon>content_copy</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="eliminaElemento(item)">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ editedItem.idDichiarazione != "-1" ? 'Modifica' : 'Aggiungi' }}
                            Dichiarazione FSC</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field v-model="editedItem.descrizione" label="Descrizione" required />
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="chiudiDialogItem">Annulla</v-btn>
                        <v-btn color="primary" @click="salvaElemento">Salva</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-dialog>
</template>

<script>
import { get_dichiarazioni, post_dichiarazione, del_dichiarazione } from '@/api/api.registroSintesi.js'

export default {
    props: {
        dialogFSC: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
    },

    data() {
        return {
            dialog: false,
            search: '',
            items: [],
            editedItem: {
                IDDichiarazione: null,
                Descrizione: ''
            },
            headers: [
                { text: 'ID', value: 'idDichiarazione' },
                { text: 'Descrizione', value: 'descrizione' },
                { text: 'Azioni', value: 'actions', sortable: false }
            ]
        }
    },

    methods: {
        async caricaDati() {
            let par = "";
            if (this.role !== "utente")
                par = "?companyCode=" + this.compCode;
            let res = await get_dichiarazioni(par);
            this.items = res.data;
        },

        apriDialogItem(item = null) {
            if (item) {
                this.editedItem = { ...item }
            } else {
                this.editedItem = {
                    companyCode: this.compCode,
                    idDichiarazione: -1,
                    descrizione: ''
                }
            }
            this.dialog = true
        },

        duplicaElemento(item) {
            this.editedItem = { ...item };
            this.editedItem.idDichiarazione = -1;
            this.dialog = true;
        },

        chiudiDialogItem() {
            this.dialog = false
        },

        async salvaElemento() {
            if (!this.editedItem.descrizione) return;
            let res = await post_dichiarazione(this.editedItem)
            if (res.data == "OK") {
                this.caricaDati()
                this.dialog = false
            } else {
                this.$toast.error("Errore. " + res.data)
            }
        },

        chiudiDialogFSC() {
            this.$emit('close')
        },

        async eliminaElemento(item) {
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare l'elemento <b>" + item.descrizione + "</b>?"
            );
            if (!confirm) return;
            let res = await del_dichiarazione(item);
            if (res.data == "OK") {
                this.caricaDati();
            }
        },
    },

    watch: {
        dialogFSC(newVal) {
            if (newVal)
                this.caricaDati();
        }
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        }
    },
}
</script>
